// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"InitialLoader_text-gradient__2UBvX","loader":"InitialLoader_loader__1zN4q","spin":"InitialLoader_spin__1eWlC"};